import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-abteilung-list-view',
  imports: [],
  templateUrl: './abteilung.list-view.html',
  styleUrls: ['./abteilung.list-view.css'],
})
export class AbteilungListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
